/* eslint-disable @typescript-eslint/consistent-type-imports */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { MenuItems } from './contracts/menu';


@Injectable()

export class MenuService {

  navExpand = new BehaviorSubject(false);
  private httpClient = inject(HttpClient);
  userScope = '';

  constructor() {
  }

  /**
   * @description  This is to highlight if the menu is selected for the menu or not // for the two level menus we are using it so created a public function
   * @param text 
   * @param menus 
   * @returns the menu selected
   */

  enableSelection(text: string, menus: MenuItems[]) {
    if (text?.length > 0) {
      for (let index = 0; index < menus.length; index++) {
        if (text === menus[index].text) {
          menus[index].isSelected = true;
        } else {
          menus[index].isSelected = false;
        }
      }
    }
    return menus
  }
  public getUserIsCorporateORSite(): Observable<any[]> {
    const url = `${environment.usercontextaggserviceUrl}/api/v1/GetSites`;
    return this.httpClient.get<any[]>(url);
  }

}
